export default __webpack_public_path__ + "static/media/tx_cube.309bc1d6.svg";